var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/gomobiledownload/viewmodels/index',["require", "exports", "common/viewmodelbase"], function (require, exports, Common) {
    "use strict";
    var GoMobileDownloadViewModel = (function (_super) {
        __extends(GoMobileDownloadViewModel, _super);
        //public breadCrumb: Portal.ModuleBreadCrumbItemHolder = new Portal.ModuleBreadCrumbItemHolder();
        function GoMobileDownloadViewModel() {
            _super.call(this);
            this.title = "Go Mobile";
            //ko.track(this, [""]); 
        }
        return GoMobileDownloadViewModel;
    }(Common.ViewModelBase));
    var instance = new GoMobileDownloadViewModel();
    return instance;
});

